import Kaia1 from '../../Media/Produk/Kaia.webp'
import Kaia2 from '../../Media/Produk/Kaia.webp'



const Kaiaimages =[
    Kaia1,Kaia2
]

export default Kaiaimages;